import React, { useState, useMemo } from "react";
import { useEffect } from "react";
import {Link, useNavigate} from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { getAllGenres, getAllPlatform, postVideogame } from "../../actions";
import "../CreateVideogame/CreateVideogame.css"


export default function VideogameCreated(){

    const dispatch = useDispatch();
    
    const platforms = useSelector((state)=> state.platform);
    const Genres = useSelector((state) => state.genres)
    const navigate = useNavigate();
    const [error, setError] = useState({})
    
    
    //que renderice los generos y plataformas
    useEffect(()=>{
        dispatch(getAllGenres());
        dispatch(getAllPlatform());
    },[dispatch])

    const [input, setInput] = useState({
        name: "",
        description: "",
        released: "",
        rating: "",
        background_image: "",
        platforms: [],
        genre: [],
    });
    //----------VALIDACIONES DE ERRORES-------------------------------
    function validacion (input) {
        let error = {}
        if (!input.name) {
          error.name = 'El nombre es requerido';
        }
        if (!input.description) {
          error.description = 'La descripcion es requerida';
        }
        if(input.rating > 5){
            error.rating = 'El maximo es 5'
          }
        if(input.rating < 0){
            error.rating = 'El minimo es 0'
        }
        if (!input.released) {
          error.released = 'Ingrese el año ';
        }
        if(!input.platforms) {
          error.platforms = 'Ingrese una plataforma';
        }
        if(!input.genre) {
            error.genre = 'Ingrese un genero';
          }
        return error;
      };

    //Deshabilitacion del boton de enviar.
      const disabledSummit = useMemo(() => {
        if (
          input.name.length > 0 &&
          input.name.length < 50 &&
          input.description.length > 0 &&
          input.description.length < 5000 &&
          input.platforms.length > 0 &&
          input.released &&
          input.rating < 5 &&
          input.rating >= 1 &&
          input.genre.length > 0
        ) {
          return false;
        } else {
          return true;
        }
      }, [input]);
/////////////////////////////////////////////HANDLES////////////////////////////////////////////////////////////////////////////////
const handleChange = (el) => {  //modifico mi estado input agregando lo q me pasan por input del form
    el.preventDefault()
    setInput((input)=>{
       const newInput={
         ...input,
         [el.target.name]: el.target.value
       }
       const error = validacion(newInput);
       setError(error);
       return newInput;
    })
     
 }
//////////////////GENERO/////////////////////////////
    function  handleSelectGenre(el){
        if(el.target.value){
            if(!input.genre.includes(el.target.value)){
                setInput({
                    ...input,
                    genre: [...input.genre,el.target.value],
                })
            }
            
        }
        if(!el.target.value){
            input.genre.splice(input.genre.indexOf(el.target.value), 1);
            setInput({
                ...input,
            });
        } setError(
            validacion({
                ...input,
                [el.target.genre]: el.target.value
            })
        )
    }
    const handleDeleteGenre = (elem) => {
        setInput({
            ...input,
            genre: input.genre.filter(item => item !== elem) //elimino las generos seleccionadas del array de genre
        })
    }
////////////////PLATAFORMAS///////////////////////////////////////    
    function  handleSelectPlatform(el){
        if(el.target.value){
            if(!input.platforms.includes(el.target.value)){
                setInput({
                    ...input,
                    platforms: [...input.platforms,el.target.value],
                })
            }
            
        }
        if(!el.target.value){
            input.platforms.splice(input.platforms.indexOf(el.target.value), 1);
            setInput({
                ...input,
            });
        } setError(
            validacion({
                ...input,
                [el.target.platforms]: el.target.value
            })
        )
    }
    const handleDeletePlatform = (elem) => {
        setInput({
            ...input,
            platforms: input.platforms.filter(item => item !== elem) //elimino las platformas seleccionadas del array de temp
        })
    }
////////////////////////////////////////////////////////////////////////////////////////    

    
    function handleSubmit(el){
        el.preventDefault();
        if(input.name &&
        input.released && 
        input.rating &&
        input.background_image &&
        input.platforms &&
        input.genre &&
        input.description) {
        dispatch(postVideogame(input))
        alert("Personaje creado con exito!!")
        setInput({
        name: "",
        description: "",
        released: "",
        rating: "",
        background_image: "",
        platforms: [],
        genre: [],
        });
        navigate('/home')
        }else {
            alert("ingrese todos los datos")}
    }
    return(
        <div className="containerForm">
             <Link className="linkVolver" to='/home'><button className="buttonVolver">Volver</button></Link>
            <form className="containerFormulario" onSubmit={(el)=>handleSubmit(el)}>
            <h2 className="tituloCreated">Ingresa tu videojuego</h2>
            {/* nombre */}
            <div>
                    <label>Nombre:</label>
                    <input className="inputName"
                        type="text" 
                        onChange={(el)=>handleChange(el)} 
                        value={input.name} 
                        name="name"
                        placeholder="Name..."
                        autoComplete="off"

                        />
                    {error.name && <p className="errores">{error.name}</p>}
                </div>
            {/* fecha (released) */}
                <div>
                    <label>Released:</label>
                    <input className="inputReleased"
                        type="date" 
                        min="1952-01-1"
                        max="2022-02-15"
                        onChange={(el)=>handleChange(el)} 
                        name="released" 
                        value={input.released}
                        placeholder="ingrese una fecha"
                        autoComplete="off"
                        />
                    {error.released && <p className="errores">{error.released}</p>}
                </div>

            {/* rating(puntuacion) */}
                <div>
                    <label>Rating:</label>
                    <input  className="inputRating"
                        type="number"
                        onChange={(el)=>handleChange(el)} 
                        name="rating" 
                        value={input.rating}
                        min="1"
                        max="5"
                        placeholder="1 - 5"
                        autoComplete="off"
                        />
                    {error.rating && <p className="errores">{error.rating}</p>}
                </div>
            {/* imagen(background_image) */}
                <div>
                    <label>Imagen:</label>
                    <input  className="inputImg"
                        onChange={handleChange} 
                        name="background_image" 
                        placeholder="URL de la imagen" 
                        type="text"
                        value={input.background_image}
                        autoComplete="off"
                    />
                </div>
            <div className="containerSelectMain">

            {/*    select para seleccionar plataformas */}
                <div className="containerPlatform">
                <select className="selectPlatform" defaultValue="Plataformas" onChange={(el) =>handleSelectPlatform(el)}>
                   <option disabled value="Plataformas">Plataformas</option>
                    {platforms.map((plat) => ( <option  key={plat.id} value={plat.name}>{plat.name}</option>))}
                </select>
                </div>

            {/*   select para seleccionar generos */}
                <select className="selectAllgenres" defaultValue="Generos" onChange={(el) =>handleSelectGenre(el)}>
                   <option disabled value="Generos">Generos</option>
                    {Genres.map((gen) => ( <option key={gen.id} value={gen.name}>{gen.name}</option>))}
                </select>
            </div>     


            <div className="containerErrorPlatyGen">
                {!input.platforms.length?(<p className="errorPlat">Campo Requerido</p>): null}
                {!input.genre.length?(<p className="errorGen">Campo Requerido</p>): null}
                </div>


                {/*te muestro los generos seleccionados y para que los puedas eliminar */}
            <div className="containerMixto">
                <p className="textGeneros">Generos: </p>
                {input.genre.map(elem =>
                <div className="container-genres" key={elem}> 
                    <p className="platform" >
                        {elem}
                    </p> 
                <button className="buttonEliminarSelect" onClick={()=> handleDeleteGenre(elem)} >X</button>
                </div>
                )}
                 {/* te muestro las plataformas seleccionadas y para que las puedas eliminar */}
                 <div className="textPlatform">
                 <p>Plataformas: </p>
                 </div>
                 {input.platforms.map(elems =>
                <div  className="container-platforms" key={elems}> 
                    <p className="platform">
                        {elems}
                    </p> 
                <button className="buttonEliminarSelect" onClick={()=> handleDeletePlatform(elems)} >X</button>
                </div>
                )} 
            </div>

            {/*  description */}
                <div>
                    <label>Description:</label>
                    <textarea className="inputTextarea" onChange={(el)=>handleChange(el)} name="description" value={input.description}/>
                </div>
                <div className="containerButtonGuardar">
                <button className="buttonGuardar" type="submit" disabled={disabledSummit}>Guardar</button>
                </div>   
            </form>
        </div>
    )

}